import React, {Fragment} from "react"
import { Link } from "react-router-dom"

const BlockStyleThree = () => {
    return (
        <Fragment>
            <div className="block-style-three mb-45">
                <h6 className="sub-title mb-20">Sobre Nosotros</h6>
                <h2 className="sect-title mb-15">Hacemos Diseño Creativo, Desarrollamos los Mejores Software</h2>
                <p>Estrategizamos continuamente ideas que cumplen con los estándares en lugar de
                    alineaciones basadas en rendimiento. Aprovechamos globalmente soluciones alternativas
                    existentes a través de usuarios virtuales.
                </p>
                <Link className="theme_btn mt-55" to="/about">Más Detalles</Link>
            </div>
        </Fragment>
    )
}

export default BlockStyleThree